import { render, staticRenderFns } from "./Typeahead.vue?vue&type=template&id=16a87059&"
import script from "./Typeahead.vue?vue&type=script&lang=ts&"
export * from "./Typeahead.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports